import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { AuthContext } from "../../components/AuthContext";
import axios from "axios";
import "./CoursesPage.css";
import { BASE_URL } from "../../config/baseUrl";

function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}/Course`)
      .then((res) => res.json())
      .then((data) => {
        const now = new Date();
        // Sort upcoming first (based on startDate) if available
        const upcoming = data.filter(c => new Date(c.startDate) >= now)
                             .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
        const completed = data.filter(c => new Date(c.startDate) < now)
                              .sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
        setCourses([...upcoming, ...completed]);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching courses:", err);
        setLoading(false);
      });
  }, []);

  const handleRegisterClick = async (course) => {
    if (!user) {
      navigate("/login");
      return;
    }

    try {
      const enrollData = {
        UserId: user.userId,
        FullName: user.fullName,
        Email: user.email,
        CatalogTypeName: "Course",
        CatalogItem: course.courseName
      };

      await axios.post(`${BASE_URL}/EnrollUser`, enrollData);

      alert(`You have successfully registered for "${course.courseName}"! Check your email.`);
    } catch (err) {
      console.error(err);
      alert("Error registering for course. Please try again.");
    }
  };

  return (
    <>
      <Navbar />

      <section className="course-hero d-flex align-items-center">
        <div className="container text-center">
          <h1 className="crimson-text">📚 Explore Our Courses</h1>
          <p>Upskill yourself with industry-relevant learning</p>
        </div>
      </section>

      <main className="main courses-page">
        <div className="container">
          {loading ? (
            <p className="loading-text">Loading courses...</p>
          ) : (
            <>
              <h2 className="section-title crimson-text mb-4">🎓 All Courses</h2>
              <div className="row">
                {courses.map((course) => (
                  <div key={course.courseId} className="col-lg-4 col-md-6 mb-4">
                    <div className="course-card h-100">
                      <div className="course-img-wrapper position-relative">
                        <img
                          src={course.coverImage || "assets/img/course-placeholder.jpg"}
                          alt={course.courseName}
                          className="img-fluid rounded"
                        />
                        {course.price ? (
                          <span className="course-price">₹{course.price}</span>
                        ) : (
                          <span className="course-price free">Free</span>
                        )}
                      </div>
                      <div className="p-3">
                        <h4>{course.courseName}</h4>
                        <p className="small text-muted">
                          • {course.level || "Beginner"}
                        </p>
                        <p>
                          {course.description?.length > 100
                            ? course.description.slice(0, 100) + "..."
                            : course.description}
                        </p>
                        {course.mentorName && (
                          <p className="mentor-name">Mentor: {course.mentorName}</p>
                        )}
                        {course.startDate && (
                          <p className="small text-muted">
                            Starts on: {new Date(course.startDate).toLocaleDateString()}
                          </p>
                        )}

                        <button
                          onClick={() => handleRegisterClick(course)}
                          className="btn-enroll-small"
                        >
                          Enroll
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}

export default CoursesPage;
